<template>
  <section>
    <section class="page1 wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0s">
      <article class="container">
        <wl-title class="h1" title='合作伙伴画像' :isNeedDesc=false></wl-title>
        <section class="img"><img class="wow flipInX" data-wow-duration="2s" data-wow-delay="0s" v-lazy="'/static/img/cooperate/1-page1.png'" alt="为乐信息科技"></section>
        <section class="flexWrap">
          <section class="box" v-for="item in page1Data" :key="item.key">
            <h3>{{item.title}}</h3>
            <section class="ul">
              <section class="li flex" v-for="(i,idx) in item.list" :key="idx">
                <section></section>
                <p>{{i}}</p>
              </section>
            </section>
          </section>
        </section>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/cooperate/1-bg1.png'">
      <article class="container">
        <wl-title title='合作伙伴赋能' :isNeedDesc=false class="title wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0ms"></wl-title>
        <section class="flexWrap wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0ms">
          <section v-for="(item,idx) in page2Data" :key="item.key" class="fl_box">
            <section class="_icon " :style="`background-position: -${92*idx}px -12px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page3">
      <article class="container">
        <wl-title title='合作流程' :isNeedDesc=false class="title wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0ms"></wl-title>
        <section class="img wow fadeInUpBig" data-wow-duration="2s" data-wow-delay="0ms"><img v-lazy="'/static/img/cooperate/1-page3.png'" alt="提交申请，合作洽谈，签订协议，加盟培训，授权证书"></section>
      </article>
    </section>
    <contact-page></contact-page>
  </section>
</template>

<script>
import contactPage from './contactPage.vue'
import WOW from 'wowjs'
export default {
  components: { contactPage },
  name: 'dealer',
  data() {
    return {
      page1Data: [
        {
          title: '广泛的人脉资源', list: [
            '属于IT集成或仪器行业', '做过高校、医院、科研院所等相关项目',
            '和当地教育主管部门和其它政府、科研单位等相关部门具有良好的公共关系']
        },
        {
          title: '强悍的销售能力', list: [
            '具备完成销售任务能力', '能够提供详细的市场开拓计划',
            '能从管理和技术角度了解和熟悉为乐信息科技实验室安全信息化系列产品']
        },
        {
          title: '完善的团队组织能力', list: [
            '能正常开展产品演示', '能提供至少一名专职销售人员及一名技术服务人员',
            '保证可以及时响应用户售前、售中和售后的服务需求']
        },
        {
          title: '良好的商业信誉', list: [
            '能正常开展产品演示', '代理合作必须是依法注册，具有独立法人地位具有合法经营权的机构',
            '必须有具备足够的流动资金，保证首批进货款及其他日常销售的需要']
        },
      ],
      page2Data: [
        { title: '商机保护', desc: '线索进行系统报备\n锁定商机信息，给予保护', key: 'cooperate1-1' },
        { title: '系统基础培训', desc: '对合作伙伴定期产品培训\n产品安装及故障排除培训', key: 'cooperate1-2' },
        { title: '商务售前培训', desc: '专业的售前咨询\n精准的需求分析\n完整的解决方案', key: 'cooperate1-3' },
        { title: '实施售后支持', desc: '多年实施技术专家远程或者现场指导实施部署\n高效的本地化服务，让用户享有最快捷的服务途径\n技术问题，提供电话、远程、现场支持服务', key: 'cooperate1-4' },
      ],
    }
  },
  mounted() {
    new WOW.WOW({ live: false }).init()
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/cooperate/icon-sprite2.png");
}
p {
  white-space: pre-line;
  font-size: 20px;
  color: #8e8e8e;
}
h3 {
  color: #262626;
  line-height: 28px;
  font-size: 28px;
  font-weight: 500;
}
.page1 {
  overflow: hidden;
  height: 1012px;
  padding-top: 136px;
  position: relative;
  .h1 {
    padding-bottom: 65px;
  }
  .img {
    width: 429px;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
  }
  .box {
    width: 378px;
    text-align: left;
    &:nth-child(1) {
      margin-right: 200px;
    }
    &:nth-child(2) {
      .ul {
        border-top: 3px solid #ffa530;
      }
    }
    &:nth-child(3) {
      padding-top: 176px;
      .ul {
        border-top: 3px solid #308dff;
      }
    }
    &:nth-child(4) {
      padding-top: 176px;
      .ul {
        border-top: 3px solid #9130ff;
      }
    }
    h3 {
      padding-bottom: 16px;
    }
    .ul {
      padding-top: 37px;
      width: 378px;
      border-top: 3px solid #40efe2;
      .li {
        section {
          width: 6px;
          height: 6px;
          background: #6d6d6d;
          border-radius: 4px;
          margin-right: 16px;
          margin-top: 12px;
          flex-shrink: 0;
        }
      }
    }
    p {
      font-size: 18px;
      color: #6d6d6d;
      padding-top: 0;
      line-height: 26px;
      padding-bottom: 8px;
    }
  }
}
.page2 {
  height: 1055px;
  overflow: hidden;
  ._icon {
    width: 92px;
    height: 92px;
    transition: all 0.2s linear;
    display: inline-block;
  }
  .title {
    padding-top: 136px;
  }
  .flexWrap {
    margin-top: 33px;
    .fl_box {
      width: 613px;
      height: 323px;
      background: #ffffff;
      border-radius: 14px;
      padding-top: 46px;
      transition: all 0.2s linear;
      margin-top: 32px;
      &:hover {
        ._icon {
          transform: translateY(-8px);
        }
      }
      h3 {
        padding-top: 8px;
        padding-bottom: 18px;
      }
      p {
        line-height: 30px;
      }
    }
  }
}
.page3 {
  overflow: hidden;
  height: 585px;
  .img {
    width: 1260px;
    margin-top: 65px;
  }
  .title {
    padding-top: 136px;
  }
}
</style>
